import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { inject, observer } from "mobx-react";
// import CheckPermission from "components/lib/CheckPermission";
import TimelineIcon from '@material-ui/icons/Timeline';
import PersonIcon from '@material-ui/icons/Person';
// import ListAltIcon from '@material-ui/icons/ListAlt';
// import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import SyncIcon from '@material-ui/icons/Sync';

// import OverView from "./overView";
import Notification from "./Notification";
// import AccessLog from "./accessLog";
// import DataRelease from "./dataRelease";
// import QATable from "./qAList";
// import AccountManage from "./accountManage";
// import Answer from "./answer";

import SystemLeftMenu from "components/organisms/SystemLeftMenu";
import AdminRouter from "shared/AdminRouter";

import HelpIcon from '@material-ui/icons/Help';
import IconButton from '@material-ui/core/IconButton';
import CustomDialog from "components/atoms/CustomDialog";
import HelpContentList from "components/atoms/CustomDialog/HelpContentList";

const styles = theme => ({
  container: {
    display: 'flex'
  },
  display: {
    borderTop: '1px solid #c6c6c6',
    height: "100%",
    padding: "50px 100px 0px 100px"
  },
  maintitle: {
    fontSize: "30px",
    textAlign: "center",
    color: "#4a4a4a",
    display: "flex",
    paddingBottom: "10px",
  },
  mainTable: {
    border: "solid 1px #c6c6c6",
    borderBottom: "0px",
    backgroundColor: "#f6f6f6",
    display: "flex"
  },
  helpIconButton: {
    color: "#3c82be",
    padding: "-4px, 0px, 0px, 5px"
  },
  helpIcon: {
    fontSize: "15px"
  },
  items: {
    padding: "0px 8px",
    color: "#7d7d7d",
    backgroundColor: "#00ff0000",
    borderBottom: "solid 1px #737272",
    minHeight: "40px"
  },
  selected: {
    color: "#ffffff",
    backgroundColor: "#00c8a3 !important"
  }
})

let list = [{ title: "OVERVIEW", icon: <TimelineIcon />, name: "OVERVIEW", url: "/admin" },
{ title: "USER ACCOUNT", icon: <PersonIcon />, name: "USER ACCOUNT", url: "/admin/useraccount" },
{ title: "SYNC LOG", icon: <SyncIcon />, name: "SYNC LOG", url: "/admin/synclog" },
// { title: "USER ACCESS LOG", icon: <ListAltIcon />, name: "USER ACCESS LOG" },
// { title: "DATA RELEASE", icon: <SettingsApplicationsIcon />, name: "DATA RELEASE" },
{ title: "Q&A BOARD", icon: <ChatBubbleOutlineIcon />, name: "Q&A BOARD", url: "/admin/qaboard" }]


@inject("comm")
@observer
class AdminPage extends Component {

  state = {
    tab: 0,
    helpOpen: false,
    imageUrl: "help/2_6_1.png",
    htmlId: 29
  }

  constructor(props) {
    super(props);
    for (let i in list) {
      if (list[i].url === this.props.location.pathname) {
        this.state = {
          tab: parseInt(i)
        }
      } else if (props.location.pathname.match("/admin/qaboard")) {
        this.state = {
          tab: 3
        }
      }
    }
  }

  componentDidUpdate() {
    for (let i in list) {
      if (list[i].url === this.props.location.pathname && this.state.tab !== parseInt(i)) {
        this.setState({
          tab: parseInt(i)
        })
      } else if (this.props.location.pathname.match("/admin/qaboard") && this.state.tab !== 3) {
        this.setState({
          tab: 3
        })
      }
    }
  }

  // 20310409 add help function : clickMainHelp, onClose by jdy
  clickMainHelp = (id) => {
    const { tab } = this.state;

    let url;
    let htmlId;

    if (0 == id) { // Overview
      if (0 == tab) {
        url = "/2_6_1.png";
        htmlId = 29;
      }
      else if (1 == tab) { // User Account
        url = "/2_6_2.png";
        htmlId = 30;  
      }
      else if (2 == tab) { // DATA SYNC, SYNC LOG
        url = "/2_6_5.png";
        htmlId = 34;  
      }      
      else { // Q&A BOARD
        url = "/2_6_3.png";
        htmlId = 31;  
      }
    }
    else if (1 == id) {
      url = "/2_6_2.png";
      htmlId = 30;
    }
    else if (2 == id) {
      url = "/2_6_5.png";
      htmlId = 34;
    }
    else if (3 == id) { // Q&A
      url = "/2_6_3.png";
      htmlId = 31;
    }
    else if (4 == id) { // Q/A Detail
      url = "/2_6_4.png";
      htmlId = 32;
    }
    else if (5 == id) { // Q/A Detail Answer
      url = "/2_6_4_1.png";
      htmlId = 33;
    }
    else {
      url = "/2_6_1.png";
      htmlId = 29;
    }

    this.setState({
      helpOpen: true,
      imageUrl: "help" + url,
      htmlId: htmlId
    });
  };

  onClose = () => {
    this.setState({
      helpOpen: false
    });
  };

  handleClick = (e, i) => {
    const { history } = this.props
    this.setState({ tab: i });
    history.push(list[i].url)
  }

  render() {
    const { classes, match, comm: { user } } = this.props;
    const { tab } = this.state;

    let helpList = [];

    helpList.length = 0;

    if (0 == tab) {
      helpList.push(
        <div style={{margin:'15px 2px 2px 20px', fontSize:'0.8em'}}>User Account </div> 
      );
      helpList.push(
        <IconButton color="primary" key={1} className={classes.helpIconButton} onClick={()=>{this.clickMainHelp(1);}}>
            <HelpIcon className={classes.helpIcon} />
        </IconButton> 
      );
      helpList.push(
        <div style={{margin:'15px 2px 2px 20px', fontSize:'0.8em'}}>Sync Log </div> 
      );
      helpList.push(
        <IconButton color="primary" key={1} className={classes.helpIconButton} onClick={()=>{this.clickMainHelp(2);}}>
            <HelpIcon className={classes.helpIcon} />
        </IconButton> 
      );
      helpList.push(
        <div style={{margin:'15px 2px 2px 20px', fontSize:'0.8em'}}>{'Q&A Board'} </div> 
      );
      helpList.push(
        <IconButton color="primary" key={1} className={classes.helpIconButton} onClick={()=>{this.clickMainHelp(3);}}>
            <HelpIcon className={classes.helpIcon} />
        </IconButton> 
      );
    }
    else if (1 == tab) {

    }
    else if (2 == tab) {

    }    
    else if (3 == tab) {
      helpList.push(
        <div style={{margin:'15px 2px 2px 20px', fontSize:'0.8em'}}>Detail </div> 
      );
      helpList.push(
        <IconButton color="primary" key={1} className={classes.helpIconButton} onClick={()=>{this.clickMainHelp(4);}}>
            <HelpIcon className={classes.helpIcon} />
        </IconButton> 
      );
      helpList.push(
        <div style={{margin:'15px 2px 2px 20px', fontSize:'0.8em'}}>Answer, Modify ... </div> 
      );
      helpList.push(
        <IconButton color="primary" key={1} className={classes.helpIconButton} onClick={()=>{this.clickMainHelp(5);}}>
            <HelpIcon className={classes.helpIcon} />
        </IconButton> 
      );
    }
    else {
      helpList = [];

      helpList.length = 0;
    }

    if (user) {
      return (
        <div className={classes.display}>
          <div className={classes.container}> 
            <div className={classes.maintitle}>
              {list[tab] ? list[tab].title : "Q&A BOARD"}
            </div>

            <div style={{margin:'0px 0px 2px 2px'}}>
              <IconButton color="primary" key={1} className={classes.helpIconButton} onClick={()=>{this.clickMainHelp(0);}}>
                <HelpIcon className={classes.helpIcon} />
              </IconButton>
            </div>

            {helpList}

            <CustomDialog
              open={this.state.helpOpen}
              onClickOpen={this.onClose}
              imageUrl={this.state.imageUrl}
              htmlId={this.state.htmlId}
              CustomDialogContent={HelpContentList}
            />
          </div>
          <div className={classes.mainTable}>

            <SystemLeftMenu list={list} tab={tab} handleClick={this.handleClick} />
            <div style={{ width: "78%" }}>
              {/* {main} */}
              <AdminRouter match={match} />
            </div>
            <div style={{ width: "22%" }}>
              <Notification />
            </div>
          </div>
        </div>

      )
    } else {
      return (
        null
      )
    }
  }
}

export default withStyles(styles)(AdminPage);;
